module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_fiat_03.1c8b68d9.jpg";